export default __webpack_public_path__ + "static/5-channel-bb4a48d31a267d51500ac8b138f1d3f1.jpg";